import { baseServiceRequest } from "@apis/baseServiceRequest"
import type {
  IGetECLAccountParams,
  IShopperShortkeyResponse,
  IShopperShortkeyBody,
  IECLResult,
  IShopper,
  ISaveShopperRequest,
} from "./types"

export const generateShortkeyLink = async (
  body: IShopperShortkeyBody,
): Promise<IShopperShortkeyResponse> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: "/shoppers/shortkey_link",
    data: body,
  })
  return response.data
}

export const getECLAccount = async (
  market_code: string,
  params: IGetECLAccountParams,
): Promise<IECLResult[]> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/shoppers/ecl/${market_code}`,
    params,
  })
  return response.data
}

export const createShopper = async (
  body: Record<string, unknown>, // Using Record<string, unknown> to allow any shape of object. Probably we should adjust as needed. Now I could use IOffersRequest... but it felt wrong
): Promise<IShopper> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: "/shoppers",
    data: body,
  })
  return response.data
}

export const saveShopper = async ({
  shopper_guid,
  data,
}: {
  shopper_guid: string
  data: ISaveShopperRequest
}): Promise<IShopper> => {
  const response = await baseServiceRequest({
    method: "POST",
    url: `/shoppers/${shopper_guid}`,
    data,
  })
  return response.data
}

export const getShopper = async (shopper_guid: string): Promise<IShopper> => {
  const response = await baseServiceRequest({
    method: "GET",
    url: `/shoppers/${shopper_guid}`,
  })
  return response.data
}
